import script from "./HtmlEditorInspector.vue?vue&type=script&setup=true&lang=js"
export * from "./HtmlEditorInspector.vue?vue&type=script&setup=true&lang=js"

import "./HtmlEditorInspector.vue?vue&type=style&index=0&id=5784b87a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5784b87a"]])

export default __exports__